// PaperPilot themes — applied by writing CSS variables to a target element.
// Theme objects override the defaults declared in styles/tokens.css.

const THEMES = {
  midnight: {
    name: '심야 인디고',
    nameEn: 'Midnight Indigo',
    description: '딥 그래파이트 + 인디고 글로우',
    swatch: ['#0B0D12', '#8896FF', '#B49BFF'],
    vars: {}, // defaults — no overrides
  },

  graphite: {
    name: '그래파이트 앰버',
    nameEn: 'Graphite Amber',
    description: '순수 차콜 + 호박색 액센트',
    swatch: ['#0A0A0A', '#E8B86A', '#D9A05B'],
    vars: {
      '--bg-0': '#070707',
      '--bg-1': '#0C0C0C',
      '--bg-2': '#121212',
      '--bg-3': '#191919',
      '--bg-4': '#212121',
      '--bg-5': '#2A2A2A',
      '--acc-indigo': '#E8B86A',
      '--acc-indigo-deep': '#C7964A',
      '--acc-violet': '#F0CB8F',
      '--acc-cyan': '#9EBEE0',
      '--acc-glow': 'rgba(232,184,106,0.18)',
      '--acc-glow-strong': 'rgba(232,184,106,0.32)',
      '--score-mid': '#F0CB8F',
      '--score-high': '#E8B86A',
    },
  },

  slate: {
    name: '슬레이트 시안',
    nameEn: 'Slate Cyan',
    description: '차가운 스틸 블루 + 시안',
    swatch: ['#0A1018', '#5EC8E0', '#7DD3C0'],
    vars: {
      '--bg-0': '#070A0F',
      '--bg-1': '#0B1018',
      '--bg-2': '#101724',
      '--bg-3': '#172132',
      '--bg-4': '#1E2A3F',
      '--bg-5': '#28354D',
      '--acc-indigo': '#5EC8E0',
      '--acc-indigo-deep': '#3FA8C0',
      '--acc-violet': '#7DD3C0',
      '--acc-cyan': '#A0DCFF',
      '--acc-glow': 'rgba(94,200,224,0.18)',
      '--acc-glow-strong': 'rgba(94,200,224,0.32)',
      '--score-mid': '#7DD3C0',
      '--score-high': '#5EC8E0',
    },
  },

  paper: {
    name: '페이퍼 라이트',
    nameEn: 'Paper Light',
    description: '편집실 톤 라이트 모드',
    swatch: ['#F4F1EA', '#4A57C8', '#7B5BCC'],
    vars: {
      '--bg-0': '#EBE6DC',       // page void
      '--bg-1': '#F4F1EA',       // app shell — paper
      '--bg-2': '#FAF7F0',       // panel
      '--bg-3': '#F0EDE5',       // card / row hover
      '--bg-4': '#E6E1D5',       // elevated
      '--bg-5': '#DDD7C8',       // pressed

      '--border-0': 'rgba(40,30,20,0.06)',
      '--border-1': 'rgba(40,30,20,0.10)',
      '--border-2': 'rgba(40,30,20,0.18)',
      '--border-3': 'rgba(40,30,20,0.28)',

      '--fg-0': '#1A1814',
      '--fg-1': '#3D3934',
      '--fg-2': '#665F55',
      '--fg-3': '#8C8478',
      '--fg-4': '#B8AE9F',

      '--acc-indigo': '#4A57C8',
      '--acc-indigo-deep': '#36419B',
      '--acc-violet': '#7B5BCC',
      '--acc-cyan': '#2F8CA8',
      '--acc-glow': 'rgba(74,87,200,0.16)',
      '--acc-glow-strong': 'rgba(74,87,200,0.28)',

      '--ok': '#458F65',
      '--ok-bg': 'rgba(69,143,101,0.10)',
      '--warn': '#A57220',
      '--warn-bg': 'rgba(165,114,32,0.10)',
      '--danger': '#B4554A',
      '--danger-bg': 'rgba(180,85,74,0.10)',
      '--info': '#2F8CA8',
      '--info-bg': 'rgba(47,140,168,0.10)',

      '--shadow-1': '0 1px 0 rgba(255,255,255,0.6) inset, 0 1px 2px rgba(40,30,20,0.08)',
      '--shadow-2': '0 10px 32px rgba(40,30,20,0.12), 0 1px 0 rgba(255,255,255,0.6) inset',
      '--glow': '0 0 0 1px rgba(74,87,200,0.30), 0 0 32px rgba(74,87,200,0.10)',

      '--score-low': '#9C7185',
      '--score-mid': '#7B5BCC',
      '--score-high': '#4A57C8',
    },
  },
};

function applyTheme(themeKey, root) {
  const theme = THEMES[themeKey] || THEMES.midnight;
  const target = root || document.documentElement;

  // Always reset first: clear any previously-applied theme overrides
  Object.keys(THEMES).forEach(k => {
    Object.keys(THEMES[k].vars).forEach(v => target.style.removeProperty(v));
  });

  // Apply new theme
  Object.entries(theme.vars).forEach(([k, v]) => {
    target.style.setProperty(k, v);
  });

  // Theme-mode hint for any conditional styles
  target.setAttribute('data-pp-theme', themeKey);
}

export { THEMES, applyTheme };
